import { CircularProgress, CircularProgressLabel, Box } from '@chakra-ui/react';
import React from 'react';

interface TaskProgressCircleProps {
  completed: number;
  total: number;
}

export const TaskProgressCircle: React.FC<TaskProgressCircleProps> = ({ completed, total }) => {
  const percent = total > 0 ? Math.round((completed / total) * 100) : 0;
  return (
    <Box>
      <CircularProgress value={percent} color="green.400" size="48px" thickness="8px">
        <CircularProgressLabel fontSize="sm">{percent}%</CircularProgressLabel>
      </CircularProgress>
    </Box>
  );
};
